export enum RetestResultStatusEnum {
    NO,
    REQUESTED,
    YES,
}
